let ePosDevice = null;
let printer = null;

export const getPrinter = () => printer;

export const connectPrinter = (
  ipAddress,
  setConnectionStatus,
  setIsVisible
) => {
  return new Promise((resolve, reject) => {
    if (printer) {
      setConnectionStatus('Already connected');
      resolve(true);
      return;
    }

    setConnectionStatus('Connecting ...');
    ePosDevice = new window.epson.ePOSDevice();

    if (ipAddress) {
      ePosDevice.connect(ipAddress, 8043, (data) => {
        if (data === 'SSL_CONNECT_OK') {
          setIsVisible(false);
          ePosDevice.createDevice(
            'local_printer',
            ePosDevice.DEVICE_TYPE_PRINTER,
            { crypto: true, buffer: false },
            (devobj, retcode) => {
              if (retcode === 'OK') {
                printer = devobj;
                setConnectionStatus('Connected');
                resolve(true);
              } else {
                setIsVisible(false);
                alert('Issue connecting to printer');
                console.error('Printer connection failed (Retcode):', retcode);
                reject(new Error('Printer connection failed: ' + retcode));
              }
            }
          );
        } else {
          setIsVisible(false);
          alert('Issue connecting to printer');
          console.error('Printer connection failed(data):', data);
          reject(new Error('SSL connection failed: ' + data));
        }
      });
    } else {
      reject(new Error('No IP address provided'));
    }
  });
};

export const disconnectPrinter = () => {
  if (ePosDevice && printer) {
    printer = null;
    ePosDevice.disconnect();
    ePosDevice = null;
  }
};
